import type { AppliedFilters } from '~/contracts/common';
import type { CvnaId } from '~/contracts/common';
import { decodeAndParse } from '~/utilities/base64';

type CvnaIdOrFilters<OtherFilters> =
  | CvnaId<OtherFilters>
  | Partial<AppliedFilters & OtherFilters>;

const isCvnaId = <OtherFilters>(
  v: CvnaIdOrFilters<OtherFilters>
): v is CvnaId<OtherFilters> =>
  'discoverLayer' in v || 'filters' in v || 'sortBy' in v || 'zip5' in v;

export default function decodeCvnaId<OtherFilters>(
  cvnaId: string
): CvnaId<OtherFilters> {
  const decodedCvnaId = decodeAndParse<CvnaIdOrFilters<OtherFilters>>(cvnaId);

  // Handle legacy capitalization
  if ('Filters' in decodedCvnaId) {
    (decodedCvnaId as any).filters = decodedCvnaId.Filters;
    delete decodedCvnaId.Filters;
  }

  return isCvnaId<OtherFilters>(decodedCvnaId)
    ? decodedCvnaId
    : { filters: decodedCvnaId };
}
